import { default as axiosService } from "axios";
export const axiosApp = axiosService.create();

/// -------------- TCM --------------

export async function updateDealAndCreateQuote() {
  const url = '' 
  const response = await axiosPOST(url, {});
  return response.data 
}
export async function getDeepLawnMeasurments(full_address) {
  const url = 'https://akxmm1eee7.execute-api.us-east-2.amazonaws.com/default/schedulerTCM_getDeepLawnForSingleFamily-git' 
  const response = await axiosPOST(url, {full_address});
  return response.data.measurementData 
}

export async function createDealTCM(formData) {
  const url = 'https://kqmucxmcb3.execute-api.us-east-2.amazonaws.com/default/schedulerTCM_createDeal-git' 
  const response = await axiosPOST(url, formData);
  return response.data.dealId 
}

export async function getDealTCM(dealId, count = 0) {
  const url = 'https://8hyk7dynf7.execute-api.us-east-2.amazonaws.com/default/schedulerTCM_get_deal_data-git' 
  const response = await axiosPOST(url, {dealId});
  const checkValue = response.data.dealData.installments.summer
  if (!checkValue) {
    if (count < 20) {
      await new Promise(resolve => setTimeout(resolve, 10000));
      const newCount = ++count
      const res = await getDealTCM(dealId, newCount)
      return res
    } else {
        return false
    }
  } else {
    return response.data.dealData 
  }
}
/// -------------- TCM --------------
export async function verifyPaymentIntentStatus(paymentIntentId) {
  const url = 'https://ymqy9xal4d.execute-api.us-east-2.amazonaws.com/default/stripePaymentVeficitation-git' 
  const response = await axiosPOST(url, {paymentIntentId});
  return response.data.paymentSuccessed 
}

export async function getNearestDatesForServices({service_type_ids, service_area}) {
  const url = 'https://wuiokzc61k.execute-api.us-east-2.amazonaws.com/default/schedulerGetNearestDatesForServices-git' 
  const response = await axiosPOST(url, {service_type_ids, service_area});
  return response.data.availability 
}

export async function getAllAppointments(paymentId) {
  const url = 'https://34wwm84h8e.execute-api.us-east-2.amazonaws.com/default/schedulerGetCustomerApptData-git' 
  const response = await axiosPOST(url, {id: paymentId});
  return response.data  
}

export async function scheduleAppointmentsPaidNow({appointments, contactData, address, serviceArea, paymentIntentId, sold_by, tip_type, tip_amount}) {
  const url = 'https://yd2th9rf95.execute-api.us-east-2.amazonaws.com/default/schedulerHandlerPayment-git'
  const response = await axiosPOST(url, {appointments, contactData, address, serviceArea, paymentIntentId, sold_by, tip_type, tip_amount});
  return response.data
}

export async function scheduleAppointmentsPayLater({appointments, contactData, address, serviceArea, paymentMethodId, sold_by, tip_type, tip_amount}) {
  const url = 'https://lz3tjgca52.execute-api.us-east-2.amazonaws.com/default/schedulerPaymentHandlerPayLater-git'
  const response = await axiosPOST(url, {appointments, contactData, address, serviceArea, paymentMethodId, sold_by, tip_type, tip_amount});
  return response.data
}

export async function scheduleAppointmentsPromoCode({appointments, contactData, address, serviceArea, sold_by, promo_code}) {
  const url = 'https://sufd2q7vw5.execute-api.us-east-2.amazonaws.com/default/schedulerScheduleAppPromoCodeHandler-git' 
  const response = await axiosPOST(url, {appointments, contactData, address, serviceArea, sold_by, promo_code});
  return response.data  
}

export async function findOrCreateStripeCustomer({email, name}) {
  const url = 'https://axzip2lod5.execute-api.us-east-2.amazonaws.com/default/searchOrCreateStripeCustomer-git' 
  const response = await axiosPOST(url, {email, name});
  return response.data.customerId  
}

export async function createSetupIntent({customerId}) {
  const url = 'https://9vxnv6jou7.execute-api.us-east-2.amazonaws.com/default/schedulerCreateSetupIntent-git' 
  const response = await axiosPOST(url, {customerId});
  return response.data  
}

export async function findOrCreateContact({contactData, jobsiteId}) {
  const url = 'https://8v4lhrat8k.execute-api.us-east-2.amazonaws.com/default/schedulerFindOrCreateContact-git' 
  const response = await axiosPOST(url, {contactData, jobsiteId});
  return response.data  
}

export async function getPaymentSecretPayNow({amount, capture_method, customerId}) {
  const url = 'https://26igvewone.execute-api.us-east-2.amazonaws.com/default/schedulerMakePayment-git' 
  const response = await axiosPOST(url, {amount, capture_method, customerId});
  return response.data  
}

export async function getJobsiteData(address) {
    const url = 'https://a5k6nuip0c.execute-api.us-east-2.amazonaws.com/default/schedulerLocationStep-git' 
    const response = await axiosPOST(url, {...address});
    return response.data  
  }

  export async function getServiceArea(address) {
    const url = 'https://ukexutxzwi.execute-api.us-east-2.amazonaws.com/default/schedulerTCM_validate_address_area-git' 
    const response = await axiosPOST(url, {...address});
    return response.data  
  }

  export async function getAcuityAvailability({service_area, service_type, requested_month, requested_year}) {
    const url = 'https://43iw0dkqbh.execute-api.us-east-2.amazonaws.com/default/schedulerGetAcuityAvailability-git' 
    const response = await axiosPOST(url, {service_area, service_type, requested_month, requested_year});
    return response.data.availability
  }


// ------------------- handlers --------------------
export function axiosGET(url) {
    const promise = axiosApp.get(url);
    return promise;
}
  
  export function axiosPOST(url, data, options = {}) {
    const promise = axiosApp.post(url, data, options);
    return promise;
  }
  
  export function axiosPUT(url, data, options = {}) {
    const promise = axiosApp.put(url, data, options);
    return promise
  }
  
  export function axiosPATCH(url, data) {
    const promise = axiosApp.patch(url, data);
    return promise
  }
  
  export function axiosDELETE(url, data) {
    const promise = axiosApp.delete(url, data);
    return promise
  }